'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of apple
 */ const Apple = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3427_20966)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M53.4761 39.5687C54.5888 33.5075 57.9586 29.2565 59.8416 27.3101C60.7736 26.3495 60.2537 24.7265 58.9381 24.4792C58.8652 24.4665 58.7891 24.4507 58.713 24.4412C56.5289 24.0924 54.3447 25.1481 53.1306 26.9994C50.7023 30.7052 50.2458 35.9865 50.2553 39.5053C46.7048 37.7206 38.171 34.6297 31.758 42.0826C23.4651 51.7196 29.6467 71.916 35.1182 78.2942C40.3869 84.4378 51.9291 79.9712 51.9291 79.9712C51.9291 79.9712 63.4681 84.4378 68.74 78.2942C74.2147 71.9129 80.3931 51.7164 72.1002 42.0826C65.6079 34.5378 56.9441 37.7935 53.4761 39.5687Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M46.2962 35.5551C47.4406 35.8436 48.5374 34.956 48.4931 33.7735C48.4138 31.7796 47.951 28.7934 46.0901 26.5014C44.2293 24.2095 41.4048 23.138 39.4679 22.6466C38.3203 22.3581 37.2235 23.2458 37.271 24.4282C37.3503 26.4222 37.8131 29.4084 39.6739 31.7035C41.5316 33.9954 44.3593 35.0669 46.293 35.5551H46.2962Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_20966",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "48.4227",
                        height: "58.9474",
                        fill: "white",
                        transform: "translate(27.7188 22.5918)"
                    })
                })
            })
        ]
    });
};

exports.Apple = Apple;
//# sourceMappingURL=Apple.cjs.map
